export default __webpack_public_path__ + "static/media/guide3.706de852.png";